import { create } from "zustand";

interface OpportunitySelectionState {
  /** Opportunity set the selection belongs to — changing set clears IDs. */
  setId: string | null;
  selectedIds: ReadonlySet<string>;
  ensureSetScope: (setId: string) => void;
  toggle: (opportunityId: string) => void;
  clear: () => void;
  /** Keep only IDs still present in `visibleIds` (e.g. after filter changes). */
  retainVisible: (visibleIds: ReadonlySet<string>) => void;
  reset: () => void;
}

const EMPTY_SELECTION: ReadonlySet<string> = new Set();

export const useOpportunitySelectionStore = create<OpportunitySelectionState>((set, get) => ({
  setId: null,
  selectedIds: EMPTY_SELECTION,

  ensureSetScope: (setId) => {
    if (get().setId === setId) return;
    set({ setId, selectedIds: new Set() });
  },

  toggle: (opportunityId) => {
    const previous = get().selectedIds;
    const next = new Set(previous);
    if (next.has(opportunityId)) next.delete(opportunityId);
    else next.add(opportunityId);
    set({ selectedIds: next });
  },

  clear: () => set({ selectedIds: new Set() }),

  retainVisible: (visibleIds) => {
    const previous = get().selectedIds;
    let changed = false;
    const next = new Set<string>();
    for (const id of previous) {
      if (visibleIds.has(id)) next.add(id);
      else changed = true;
    }
    if (changed) set({ selectedIds: next });
  },

  reset: () => set({ setId: null, selectedIds: EMPTY_SELECTION }),
}));
